import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import dayjs from "dayjs";

/**
 * GenerateInformacaoObraColumns
 */

type Props = {
  onActionEditar: (idInformacaoObra: number | null, openState: boolean) => void,
  onActionDeletar: (idInformacaoObra: number | null, openState: boolean) => void,
};

export const GenerateObraInformacoesColumns = ({
  onActionEditar,
  onActionDeletar,
}: Props): GridColDef[] => {
  return [
    {
      field: "nome",
      filterable: false,
      headerName: "Responsável",
      width: 350,
      minWidth: 150,
      sortable: false,
      headerClassName: 'funcionarios-header',
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex items-center text-xs py-2">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "data",
      filterable: false,
      headerName: "Data",
      width: 100,
      minWidth: 100,
      sortable: false,
      headerClassName: 'funcionarios-header',
      renderCell: (param) => (
        <div className="w-full h-full flex items-center text-xs py-2">
          {param.value && dayjs(param.value).format('DD/MM/YYYY')}
        </div>
      ),
    },
    {
      field: "descInformacoes",
      filterable: false,
      headerName: "Informações",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: 'funcionarios-header',
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex items-center text-xs py-2">
            {params.value}
          </div>
        );
      }
    },
    {
      field: 'idObraInformacoes',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      minWidth: 100,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onActionEditar(params.value, true)}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => onActionDeletar(params.value, true)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}